<template>

  <div class="ui grid animated fadeIn">

    <div class="sixteen wide column">

      <div v-if="currentView == 'items'" class="ui segment animated fadeIn">        
        <h4 class="ui dividing header">Itens</h4>
        <button v-if="showBatchPriceUpdateButton" class="ui basic blue small button" @click="currentView = 'batch_price_update'">
          <i class="edit icon"></i>
          Alterar Preços
        </button>
        <div v-if="showApprovalButtons" class="m-b-15">
          <button class="ui basic blue small button" @click="currentView = 'batch_approval'">
            <i class="list icon"></i>
            Aprovar em Lote
          </button>
          <button class="ui basic teal small button m-l-10" @click="currentView = 'prices_approval'">
            <i class="check square icon"></i>
            Aprovar por Itens
          </button>
        </div>        
        <div class="ui basic segment">
          <table class="ui very basic selectable celled tablet stackable table">
            <thead class="desktop-only">
              <tr>
                <th>Produto</th>
                <th>Quantidade</th>
                <th>Preço Mínimo</th>
                <th>Desc. Máximo</th>
                <th>Preço Padrão</th>
                <th>Desc. Padrão</th>
                <th>Preço Sugerido</th>
                <th>Desc. Sugerido</th>
                <th>Preço Aprovado</th>
                <th>Total Aprovado</th>
                <th>% Com. Sug.</th>
                <th>% Com. Aprov.</th>
                <th>Tolerância</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in quotation.items" class="clickable" @click="showProduct(item)">
                <td>
                  <span v-if="isObject(item.item)" v-html="isObject(item.status.html) ? item.status.html.__old : item.status.html"></span>
                  <span v-if="isObject(item.item)">Antes: {{ item.item.__old }} -  {{ isObject(item.description) ? item.description.__old : item.description }}</span>
                  <span v-html="isObject(item.status.html) ? item.status.html.__new : item.status.html"></span>
                  <span> {{ isObject(item.item) ? item.item.__new : item.item }} - {{ isObject(item.description) ? item.description.__new : item.description }}</span>
                </td>
                <td><strong class="mobile-only">Quantidade: </strong>
                <span v-if="isObject(item.quantity)" :class="{ 'red text': isObject(item.quantityAlert) ? item.quantityAlert.__old : item.quantityAlert }">Antes: {{ $formatInteger(item.quantity.__old) }}</span>
                <span :class="{ 'red text': isObject(item.quantityAlert) ? item.quantityAlert.__new : item.quantityAlert }"> {{ isObject(item.quantity) ? $formatInteger(item.quantity.__new) : $formatInteger(item.quantity) }}</span>  
                </td>
                <td>
                  <strong class="mobile-only">Preço Mínimo: </strong>
                  <span v-if="isObject(item.minPrice)">Antes: R$ {{ $formatCurrencyWith4Decimals(item.minPrice.__old) }}</span>
                  <span> R$ {{ isObject(item.minPrice) ? $formatCurrencyWith4Decimals(item.minPrice.__new) : $formatCurrencyWith4Decimals(item.minPrice) }}</span>
                </td>
                <td>
                  <strong class="mobile-only">Desc. Máximo: </strong>
                  <span v-if="isObject(item.minPriceDiscount)">Antes: {{ item.minPriceDiscount.__old }}</span>
                  <span> {{ isObject(item.minPriceDiscount) ? item.minPriceDiscount.__new : item.minPriceDiscount }}</span>
                </td>
                <td>
                  <strong class="mobile-only">Preço Padrão: </strong>
                  <span v-if="isObject(item.stdPrice)">Antes: R$ {{ $formatCurrencyWith4Decimals(item.stdPrice.__old) }}</span>
                  <span> R$ {{ isObject(item.stdPrice) ? $formatCurrencyWith4Decimals(item.stdPrice.__new) : $formatCurrencyWith4Decimals(item.stdPrice || (isObject(item.minPrice) ? item.minPrice.__new : item.minPrice)) }}</span>
                </td>
                <td>
                  <strong class="mobile-only">Desc. Padrão: </strong>
                  <span v-html="getStdDiscount(item)"></span>
                </td>
                <td :class="{ 'red text': isObject(item.sugPriceAlert) ? item.sugPriceAlert.__new : item.sugPriceAlert}">
                  <strong class="mobile-only">Preço Sugerido: </strong>
                  <span v-if="isObject(item.sugPrice)" :class="{ 'red text': isObject(item.sugPriceAlert) ? item.sugPriceAlert.__old : item.sugPriceAlert }">Antes: R$ {{ $formatCurrencyWith4Decimals(item.sugPrice.__old) }}</span>
                  <span :class="{ 'red text': isObject(item.sugPriceAlert) ? item.sugPriceAlert.__new : item.sugPriceAlert }"> R$ {{ isObject(item.sugPrice) ? $formatCurrencyWith4Decimals(item.sugPrice.__new) : $formatCurrencyWith4Decimals(item.sugPrice) }}</span>
                </td>
                <td>
                  <strong class="mobile-only">Desc. Sugerido: </strong>
                  <span v-html="getSugDiscount(item)"></span>
                </td>
                <td :class="{ 'red text': isObject(item.appPriceAlert) ? item.appPriceAlert.__new : item.appPriceAlert }">
                  <strong class="mobile-only">Preço Aprovado: </strong>
                  <span v-if="isObject(item.appPriceAlert)" :class="{ 'red text': isObject(item.appPriceAlert) ? item.appPriceAlert.__old : item.appPriceAlert }">Antes: R$ {{ $formatCurrencyWith4Decimals(item.appPrice.__old) }}</span>
                  <span :class="{ 'red text': isObject(item.appPriceAlert) ? item.appPriceAlert.__new : item.appPriceAlert }"> R$ {{ isObject(item.appPrice) ? $formatCurrencyWith4Decimals(item.appPrice.__new) : $formatCurrencyWith4Decimals(item.appPrice) }}</span>
                </td>
                <td>
                  <strong class="mobile-only">Total Aprovado: </strong>
                  <span v-if="isObject(item.appTotal)">Antes: R$ {{ $formatCurrency(item.appTotal.__old) }}</span>
                  <span> R$ {{ isObject(item.appTotal) ? $formatCurrency(item.appTotal.__new) : $formatCurrency(item.appTotal) }}</span>
                </td>
                <td>
                  <strong class="mobile-only">% Com. Sug.: </strong>
                  <span v-if="isObject(item.sugCommission)">Antes: {{ $formatCurrency(item.sugCommission.__old) }}%</span>
                  <span> {{ isObject(item.sugCommission) ? $formatCurrency(item.sugCommission.__new) : $formatCurrency(item.sugCommission) }}%</span>
                </td>
                <td>
                  <strong class="mobile-only">% Com. Aprov.: </strong>
                  <span v-if="isObject(item.appCommission)">Antes: {{ $formatCurrency(item.appCommission.__old) }}%</span>
                  <span> {{ isObject(item.appCommission) ? $formatCurrency(item.appCommission.__new) : $formatCurrency(item.appCommission) }}%</span>
                </td>
                <td>
                  <strong class="mobile-only">Tolerância: </strong>
                  <span v-if="isObject(item.itemAcceptTolerance)">
                    Antes: {{ item.itemAcceptTolerance.__old === 'S' ? 'Sim' : 'Não' }} → 
                  </span>
                  {{ isObject(item.itemAcceptTolerance) ? (item.itemAcceptTolerance.__new === 'S' ? 'Sim' : 'Não') : (item.itemAcceptTolerance === 'S' ? 'Sim' : 'Não') }}
                </td>
              </tr>            
            </tbody>
          </table>
        </div>
      </div>

      <batch-price-update v-if="currentView == 'batch_price_update'" :quotation="quotation" 
        @onUpdate="$emit('onBatchPriceUpdate')" @onCancel="currentView = 'items'"/>

      <batch-approval v-if="currentView == 'batch_approval'" :quotation="quotation" 
        @onUpdate="$emit('onBatchApproval')" @onCancel="currentView = 'items'"/>

      <prices-approval v-if="currentView == 'prices_approval'" :quotation="quotation" 
        @onUpdate="$emit('onPricesApproval')" @onCancel="currentView = 'items'"/>

      <quotation-totals :quotation="quotation" />

      <product-dialog ref="productDialog" :item="selectedItem" />

    </div>    

  </div>

</template>

<script>

  import QuotationTotals from "./totals.vue"
  import ProductDialog from "./product-dialog.vue"
  import BatchPriceUpdate from "./batch-price-update.vue"
  import BatchApproval from "./batch-approval.vue"
  import PricesApproval from "./prices-approval.vue"
  import QuotationService from "@/services/quotation-service"

  export default {

    data() {
      return {
        selectedItem: null,
        currentView: "items",
      }
    },

    props: ["quotation"],

    computed: {

      showBatchPriceUpdateButton() {
        return (this.quotation.isOwner && !this.quotation.isApprover && this.quotation.allowUpdate)        
      },

      showApprovalButtons() {

        let show = true
        const user = this.$store.state.user
        const quotation = this.quotation

        if ( (!(user.isApprover && (quotation.approvingly || quotation.waitingTecnicalApproval))) || 
           ((quotation.approvingly || quotation.waitingTecnicalApproval) && 
           (quotation.hasOwnProperty('approver') && user.id !== quotation.approver.id)) || quotation.revision)	{
          show = false
        }

        return show
      },
    },

    components: {
      QuotationTotals,
      ProductDialog,
      BatchPriceUpdate,
      BatchApproval,
      PricesApproval,      
    },

    mounted() {

      $(".quotation-item-icon").popup()
    },

    methods: {

      showProduct(item) {

        this.selectedItem = item

        this.$refs.productDialog.show()
      },

      getSugDiscount(item) {
        // Mod20634-1: sempre exibir desconto. Numero negativo em vermelho para sinalizar anomalia.
        const typed = this.isObject(item.sugDiscTyped) ? item.sugDiscTyped.__new : item.sugDiscTyped
        const discount = this.isObject(item.sugDiscount) ? item.sugDiscount.__new : item.sugDiscount
        const def = this.isObject(item.defDiscount) ? item.defDiscount.__new : item.defDiscount
        const sugPrice = this.isObject(item.sugPrice) ? item.sugPrice.__new : item.sugPrice
        const stdPrice = this.isObject(item.stdPrice) ? item.stdPrice.__new : item.stdPrice
        if (stdPrice && Number(sugPrice) > Number(stdPrice)) {
          const n = Number(discount)
          if (!isNaN(n)) {
            return n < 0
              ? `<span class="red text">${discount}</span>`
              : String(discount)
          }
        }
        if (typed) return QuotationService.formatDiscountFromTyped(typed)
        return QuotationService.formatDiscountWithDef(discount, def)
      },

      getStdDiscount(item) {
        return (this.isObject(item.defDiscount) ? item.defDiscount.__new : item.defDiscount) || ''
      },

      isObject(value) {
        if (typeof value == "object" && value != null) {
          return true
        }
        return false
      },
    },
  }

</script>
